const initialState = {
  IsrPlataformRanges: [
    {
      id: 1,
      lowerLimit: 0.01,
      upperLimit: 5500,
      porcentage: 0.02,
      year: 2020,
    },
    {
      id: 2,
      lowerLimit: 5500.1,
      upperLimit: 15000,
      porcentage: 0.03,
      year: 2020,
    },
    {
      id: 3,
      lowerLimit: 15000.1,
      upperLimit: 21000,
      porcentage: 0.04,
      year: 2020,
    },
    {
      id: 4,
      lowerLimit: 21000.1,
      upperLimit: null,
      porcentage: 0.08,
      year: 2020,
    },
    {
      id: 1,
      lowerLimit: 0.01,
      upperLimit: null,
      porcentage: 0.021,
      year: 2021,
    },
    {
      id: 1,
      lowerLimit: 0.01,
      upperLimit: null,
      porcentage: 0.021,
      year: 2022,
    },
    {
      id: 1,
      lowerLimit: 0.01,
      upperLimit: null,
      porcentage: 0.021,
      year: 2023,
    },
    {
      id: 1,
      lowerLimit: 0.01,
      upperLimit: null,
      porcentage: 0.021,
      year: 2024,
    },
    {
      id: 1,
      lowerLimit: 0.01,
      upperLimit: null,
      porcentage: 0.021,
      year: 2025,
    },
    {
      id: 1,
      lowerLimit: 0.01,
      upperLimit: null,
      porcentage: 0.021,
      year: 2026,
    },
  ],
};
// 626 - Plataformas Tecnológicas  Servicio Terrestre
export const IsrPlataformReducer = (state = initialState, action) => {
  switch (action.type) {
    default:
      return state;
  }
};
